import { ErrorHandler, Injectable } from '@angular/core';
import { AuthRedirectService } from '../auth/auth-redirect.service';

/**
 * Global Angular ErrorHandler — catches Auth0 session-expiry errors that
 * surface as unhandled RxJS errors (i.e. thrown to a subscriber with no
 * error callback) and redirects to login.  Acts as a safety net in addition
 * to the authErrorInterceptor.
 */
@Injectable()
export class AuthErrorHandler implements ErrorHandler {
  // NOTE: ErrorHandler is instantiated outside Angular's injection context,
  // so inject() does not work here — constructor injection is required.
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(private readonly authRedirect: AuthRedirectService) {}

  handleError(error: unknown): void {
    if (this.authRedirect.isAuthError(error)) {
      this.authRedirect.redirectToLogin();
      return;
    }
    console.error(error);
  }
}
